const defaultAccountListState = {
  accountListData: null,
  loadingState: {
    isLoadingAccounts: false,
  },
  errorState: {
    accountsDataError: undefined,
  },
  onAccountListRefetch: () => {},
};

export { defaultAccountListState };
